// Was jede Seite des CRM über die Anmeldung wissen muss – wer angemeldet
// ist (mit Rolle und Firma) und die Hilfen der Anmeldung (abmelden, neu
// fragen) –, einmal oben hineingereicht statt durch jede Seite durch.

import { createContext, useContext } from "react";
import type { IchAntwort } from "@happy-energy/kern";
import type { AnmeldungHilfen } from "@happy-energy/oberflaeche";

export interface CrmZusammenhang {
  ich: IchAntwort;
  hilfen: AnmeldungHilfen;
}

export const CrmKontext = createContext<CrmZusammenhang | null>(null);

/** Wer angemeldet ist – nur innerhalb von <Crm> gültig. */
export function useCrm(): CrmZusammenhang {
  const z = useContext(CrmKontext);
  if (!z) throw new Error("useCrm außerhalb von <Crm>");
  return z;
}
